var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#6708FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 15.0003V19.5837C24.1668 22.3337 22.3335 24.167 19.5835 24.167H10.4168C7.66683 24.167 5.8335 22.3337 5.8335 19.5837V15.0003C5.8335 12.507 7.33683 10.7653 9.67433 10.472C9.91266 10.4353 10.1602 10.417 10.4168 10.417H19.5835C19.8218 10.417 20.051 10.4261 20.271 10.4628C22.636 10.7378 24.1668 12.4887 24.1668 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.272 10.4622C20.052 10.4255 19.8228 10.4164 19.5845 10.4164H10.4178C10.1611 10.4164 9.91363 10.4347 9.67529 10.4713C9.80363 10.2147 9.98696 9.97635 10.207 9.75635L13.1861 6.76801C14.442 5.52134 16.477 5.52134 17.7328 6.76801L19.337 8.39053C19.9236 8.96803 20.2353 9.70134 20.272 10.4622Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 15.458H21.4168C20.4085 15.458 19.5835 16.283 19.5835 17.2913C19.5835 18.2997 20.4085 19.1247 21.4168 19.1247H24.1668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseBagIcon);
export default __webpack_public_path__ + "static/media/PurchaseBagIcon.5e8ea87630c4c22b593273b4287408e9.svg";
export { ForwardRef as ReactComponent };